import { Injectable } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { DatastoreService } from './datastore.service';

@Injectable({
  providedIn: 'root',
})
export class CommonFunctionsService {
  constructor(private datastore: DatastoreService) {
  }

  cleanData(data: any) {
    return Object.fromEntries(
      Object.entries(data).filter(([_, v]) => v !== "" && v !== null && v !== undefined)
    );
  }

  mergeAnswers(oldData: any, newData: any) {
    return { ...oldData, ...newData };
  }

  buildForm(data: any) {
    const form = this.datastore.companyQuestionsForm;

    if (!form) {
      this.datastore.companyQuestionsForm = new FormGroup({});
    }

    Object.keys(data).forEach(key => {
      if (!this.datastore.companyQuestionsForm.contains(key)) {
        this.datastore.companyQuestionsForm.addControl(key, new FormControl(''));
      }
    });

    return this.datastore.companyQuestionsForm;
  }

  updateAnswers(event: { formData?: any }) {
    if (!event?.formData) return;

    // Ensure the form exists
    if (!this.datastore.companyQuestionsForm) {
      this.datastore.companyQuestionsForm = new FormGroup({});
    }

    const form = this.datastore.companyQuestionsForm;

    const cleaned = this.cleanData(event.formData);
    const merged = this.mergeAnswers(form.value || {}, cleaned);

    this.buildForm(merged);
    form.patchValue(merged);

    console.log('Updated shared form value:', form.value);
  }

  storeSchema(schema: Record<string, any>) {
    this.datastore.serviceQuestionSchema = schema;
  }

  updateDatastore(event: Record<string, any>) {
    Object.keys(event).forEach(key => {
      console.log(`Updating datastore key: ${key} with value: `, event[key]);
      this.datastore[key] = event[key];
    });
  }
}
